import { useEffect } from 'react';

const useScrollEnd = (ref, loadState, handler) => {
  useEffect(() => {
    const isWindow = ref.current === window;

    const scrollEvent = event => {
      if (!loadState.current.canLoad) return;

      if (isWindow) {
        if (window.innerHeight + Math.round(window.scrollY) >= document.body.offsetHeight - 250) {
          handler(loadState.current.token);
        }
      } else {
        const currentScroll = ref.current.offsetHeight + ref.current.scrollTop + 1;
        if (currentScroll >= ref.current.scrollHeight) {
          handler(loadState.current.token);
        }
      }
    };

    ref.current?.addEventListener('scroll', scrollEvent);

    return () => {
      ref.current?.addEventListener('scroll', scrollEvent);
    };
    //eslint-disable-next-line
  }, [ref, handler]);
};

export default useScrollEnd;
